import api from './index';
import { withRuntimeUrl } from './runtimeConfig';
import { UMS_ACCOUNT_NAME } from 'containers/Authentication/constants';

const withRuntimeUmsUrl = (buildRequest: (arg: any) => any) =>
  withRuntimeUrl('umsUrl', 'UMS URL not configured in ETCD', buildRequest);

const umsApi = api.injectEndpoints({
  endpoints: build => ({
    loginUMS: build.mutation({
      queryFn: withRuntimeUmsUrl(body => ({
        method: 'POST',
        url: '/v2/sign-in',
        body,
      })),
    }),
    requestAccess: build.mutation({
      queryFn: withRuntimeUmsUrl(body => ({
        method: 'POST',
        url: `/v2/account-access/${UMS_ACCOUNT_NAME}`,
        body,
      })),
    }),
    forgotPassword: build.mutation({
      queryFn: withRuntimeUmsUrl(body => ({
        method: 'POST',
        url: '/v2/forgot-password',
        body,
      })),
    }),
    updatePassword: build.mutation({
      queryFn: withRuntimeUmsUrl(body => ({
        method: 'POST',
        url: '/v2/update-password',
        body,
      })),
    }),
    registerUser: build.mutation({
      queryFn: withRuntimeUmsUrl(({ body, params }) => ({
        method: 'POST',
        url: '/v2/sign-up',
        body,
        params,
      })),
    }),
    verifyEmail: build.mutation({
      queryFn: withRuntimeUmsUrl(body => ({
        method: 'POST',
        url: '/v2/verify-email',
        body,
      })),
    }),
    getUMSIdForGoogleLogin: build.mutation({
      queryFn: withRuntimeUmsUrl(token => ({
        method: 'GET',
        url: '/v1/users/details',
        headers: {
          'authorization-token': token,
        },
      })),
    }),
  }),
});

export const {
  useLoginUMSMutation,
  useRequestAccessMutation,
  useForgotPasswordMutation,
  useUpdatePasswordMutation,
  useRegisterUserMutation,
  useVerifyEmailMutation,
  useGetUMSIdForGoogleLoginMutation,
} = umsApi;
